import {
  TableContainer as MUITableContainer,
  TableContainerProps,
} from '@mui/material';

export { type TableContainerProps } from '@mui/material';

export function TableContainer(props: TableContainerProps) {
  return <MUITableContainer {...props} />;
}
